import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';
import { PlantsModel } from '../models-otc/plants-model';

@Injectable({
  providedIn: 'root'
})
export class PlantSelectionService {
private selectedPlantSubject = new BehaviorSubject<PlantsModel | null>(null);
  // selectedPlant$ = this.selectedPlantSubject.asObservable();

  setSelectedPlant(plant: PlantsModel) {
    this.selectedPlantSubject.next(plant);
    console.log('Plant selected:', plant);
  }

  getSelectedPlant(): PlantsModel | null {
    console.log('this.selectedPlantSubject.value:', this.selectedPlantSubject.value);
    return this.selectedPlantSubject?.value;
  }

  clearSelectedPlant() {
    this.selectedPlantSubject.next(null);
  }
}
